import React from "react";

const Title = ({ title = "Title", className = "" }) => {
  return (
    <div
      className={`text-primary border-primary w-fit rounded-tr-[20px] rounded-bl-[20px] border-[0.5px] p-2.5 text-2xl font-medium ${className}`}
    >
      {title}
    </div>
  );
};

export default Title;
